/* FondoCero · <fc-ugc> (videos play in view), <fc-tabs>, <fc-compact-bundle>. Requires fc-cart.js. */
(() => {
  'use strict';
  const FC = (window.FC = window.FC || {});
  const define = (name, cls) => {
    if (!customElements.get(name)) customElements.define(name, cls);
  };

  define(
    'fc-ugc',
    class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onClick);
        if (!('IntersectionObserver' in window) || (FC.reducedMotion && FC.reducedMotion())) return;
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target;
              if (entry.isIntersecting && entry.intersectionRatio >= 0.5 && !video.closest('[hidden]')) {
                video.muted = video.dataset.fcUnmuted !== 'true';
                const p = video.play();
                if (p && p.catch) p.catch(() => {});
              } else {
                video.pause();
              }
            });
          },
          { threshold: [0, 0.5] }
        );
        this.querySelectorAll('video').forEach((v) => this.observer.observe(v));
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
      onClick = (event) => {
        const btn = event.target.closest('[data-fc-sound]');
        if (!btn) return;
        const video = btn.parentElement.querySelector('video');
        if (!video) return;
        const unmute = video.muted;
        this.querySelectorAll('video').forEach((v) => {
          v.muted = true;
          v.dataset.fcUnmuted = 'false';
        });
        this.querySelectorAll('[data-fc-sound]').forEach((b) => b.setAttribute('aria-pressed', 'false'));
        if (unmute) {
          video.muted = false;
          video.dataset.fcUnmuted = 'true';
          btn.setAttribute('aria-pressed', 'true');
          const p = video.play();
          if (p && p.catch) p.catch(() => {});
        }
      };
    }
  );

  define(
    'fc-tabs',
    class extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.addEventListener('click', (e) => {
          const tab = e.target.closest('[role="tab"]');
          if (tab) this.select(tab);
        });
        this.addEventListener('keydown', (e) => {
          const i = this.tabs.indexOf(document.activeElement);
          if (i < 0 || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
          e.preventDefault();
          const next = this.tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length];
          this.select(next);
          next.focus();
        });
      }
      select(tab) {
        this.tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-selected', String(on));
          t.tabIndex = on ? 0 : -1;
          const panel = this.querySelector(`#${t.getAttribute('aria-controls')}`);
          if (!panel) return;
          panel.hidden = !on;
          panel.querySelectorAll('video').forEach((v) => {
            if (on) {
              v.muted = true;
              const p = v.play();
              if (p && p.catch) p.catch(() => {});
            } else v.pause();
          });
        });
      }
    }
  );

  define(
    'fc-compact-bundle',
    class extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('[data-fc-compact-list]');
        this.errorEl = this.querySelector('[data-fc-compact-error]');
        this.addEventListener('change', this.onChange);
        const atc = this.querySelector('[data-fc-compact-atc]');
        if (atc) atc.addEventListener('click', () => FC.product && FC.product.addSelected(this.errorEl));
        document.addEventListener('fc:pack-change', this.sync);
        if (FC.onReady) FC.onReady(() => this.render());
      }
      disconnectedCallback() {
        document.removeEventListener('fc:pack-change', this.sync);
      }
      render() {
        const product = FC.product;
        const config = FC.config;
        if (!product || !config || !config.packs.length) {
          this.closest('.fc-compact').hidden = true;
          return;
        }
        const media = this.querySelector('[data-fc-final-media]');
        if (media && !media.querySelector('img') && config.heroImage) {
          media.innerHTML = `<img src="${FC.esc(config.heroImage)}" alt="" loading="lazy" width="900" height="900">`;
        }
        const name = `fc-compact-${this.dataset.section}`;
        this.list.innerHTML = config.packs
          .filter((p) => p.available)
          .map(
            (p) => `<label class="fc-cpack${p.index === product.index ? ' is-selected' : ''}"><input type="radio" name="${name}" value="${p.index}"${p.index === product.index ? ' checked' : ''}>${p.badge ? `<span class="fc-cpack__badge">${FC.esc(p.badge)}</span>` : ''}<span class="fc-cpack__units">${FC.esc(p.title)}</span><span class="fc-cpack__price">${FC.money(product.pricing(p).now)}</span>${product.pricing(p).was > product.pricing(p).now ? `<s><span class="fc-visually-hidden">Regular price </span>${FC.money(product.pricing(p).was)}</s>` : '<span class="fc-cpack__name">&nbsp;</span>'}</label>`
          )
          .join('');
        const total = this.querySelector('[data-fc-total]');
        if (total) {
          total.dataset.fcValue = product.total();
          total.textContent = FC.money(product.total());
        }
      }
      onChange = (event) => {
        if (event.target.name && event.target.name.indexOf('fc-compact-') === 0 && FC.product) {
          FC.product.select(Number(event.target.value), { source: 'compact' });
        }
      };
      sync = (event) => {
        if (event.detail && event.detail.source === 'phase') return this.render();
        this.querySelectorAll('.fc-cpack').forEach((label) => {
          const input = label.querySelector('input');
          const on = Number(input.value) === event.detail.index;
          input.checked = on;
          label.classList.toggle('is-selected', on);
        });
      };
    }
  );
})();
